import React from 'react'
import { connect } from 'react-redux'

import BannerActions from '../../Redux/BannerRedux'

class UpdateContent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        title: props.detail.title,
        priority: props.detail.priority,
        link: props.detail.link,
        iso_code: props.detail.iso_code
      }
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value.replace(/[^\x20-\x7E]/g, '')
    if (event.target.type === 'number') {
      val = parseInt(val, 10)
    }
    let form = { ...this.state.form }
    form[field] = val
    this.setState({ form })
  }

  _valueChange = (event) => {
    let val = event.target.value
    if (parseFloat(val) > 1000) {
      val = 1000
    } else if (parseFloat(val) < 1) {
      val = 1
    }
    let form = { ...this.state.form }
    form.priority = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    const data = {
      id: this.props.detail.id,
      form: this.state.form
    }
    this.props.updateBanner(data)

    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Banner</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title</label>
            </div>
            <div className='col-9'>
              <input type='text' required placeholder='Banner Title' className='form-control' value={this.state.form.title} onChange={(event) => this._inputChange(event, 'title')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Link</label>
            </div>
            <div className='col-9'>
              <input type='text' required placeholder='Link Banner' className='form-control' value={this.state.form.link} onChange={(event) => this._inputChange(event, 'link')} />
              <small className='form-text text-muted'>URL must contain https://</small>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Priority</label>
            </div>
            <div className='col-9'>
              <input type='number' required className='form-control' value={this.state.form.priority} onChange={(event) => this._valueChange(event)} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Source</label>
            </div>
            <div className='col-9'>
              <select className='form-control' value={this.state.form.iso_code} onChange={(event) => this._inputChange(event, 'iso_code')}>
                <option value='ID'>ID</option>
                <option value='PH'>PH</option>
              </select>
            </div>
          </div>
          <div className='form-group d-flex justify-content-end'>
            <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
            <button className='btn btn-lg btn-primary' type='submit'>Save</button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  updateBanner: (data) => dispatch(BannerActions.bannerUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateContent)



// WEBPACK FOOTER //
// ./src/Containers/Banner/UpdateContent.js